module.exports = __webpack_public_path__ + "img/transport_smvf.c4bf1a24.jpg";